import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, errText } from "@/lib/api";
import { useLang } from "@/lib/i18n";

const input = "w-full h-12 px-4 rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-teal-500";
const Card = ({ children }) => (
  <div className="min-h-screen bg-[#FAF6EF] flex items-center justify-center px-4">
    <div className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 p-5 space-y-4 shadow-sm fade-in">{children}</div>
  </div>
);

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const { t } = useLang();
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); } catch (err) {}
    setSent(true);
  };
  return (
    <Card>
      <h1 className="font-heading font-bold text-lg text-slate-900">{t("forgotPassword")}</h1>
      {sent ? (
        <p data-testid="forgot-sent-msg" className="text-sm text-slate-600">If that email is registered, a reset link has been sent.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="forgot-email-input" type="email" className={input} placeholder={t("email")} value={email} onChange={(e) => setEmail(e.target.value)} required />
          <button data-testid="forgot-submit-btn" className="w-full h-12 rounded-xl bg-slate-900 text-white font-semibold">{t("sendResetLink")}</button>
        </form>
      )}
      <Link data-testid="back-to-signin-link" to="/login" className="block text-sm text-teal-700">{t("backToSignIn")}</Link>
    </Card>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { t } = useLang();
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      navigate("/login");
    } catch (err) { setError(errText(err.response?.data?.detail) || err.message); }
  };
  return (
    <Card>
      <h1 className="font-heading font-bold text-lg text-slate-900">{t("resetPassword")}</h1>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="reset-password-input" type="password" className={input} placeholder={t("newPassword")} value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
        {error && <p data-testid="reset-error" className="text-sm text-red-600">{error}</p>}
        <button data-testid="reset-submit-btn" className="w-full h-12 rounded-xl bg-slate-900 text-white font-semibold">{t("resetPassword")}</button>
      </form>
      <Link data-testid="reset-back-link" to="/login" className="block text-sm text-teal-700">{t("backToSignIn")}</Link>
    </Card>
  );
}
